export interface DataItem {
    key: string;
    datum: string;
    uzivatel: string;
    zeme: string;
    flagCode: string;
    kategorie: string;
    nabidka: string;
    typ: string;
    id: string;
    odmena: string;
    castka: string;
}

export const data: DataItem[] = [
    {
        key: "1",
        datum: "12.12.2021 10:45",
        uzivatel: "Michael Bauer",
        zeme: "Rakousko",
        flagCode: "at",
        kategorie: "Finance",
        nabidka: "Raiffeisen",
        typ: "Click",
        id: "210",
        odmena: "150",
        castka: "2,540.75",
    },
    {
        key: "2",
        datum: "15.11.2021 14:20",
        uzivatel: "Sophie Johnson",
        zeme: "Spojené státy",
        flagCode: "us",
        kategorie: "Finance",
        nabidka: "AirBank",
        typ: "iFrame",
        id: "211",
        odmena: "180",
        castka: "12,345.67",
    },
    {
        key: "3",
        datum: "18.12.2021 09:00",
        uzivatel: "Lucas Müller",
        zeme: "Německo",
        flagCode: "de",
        kategorie: "Finance",
        nabidka: "Deutsche Bank",
        typ: "Lead",
        id: "212",
        odmena: "220",
        castka: "9,876.54",
    },
    {
        key: "4",
        datum: "20.12.2021 11:15",
        uzivatel: "Emily Novak",
        zeme: "Česká republika",
        flagCode: "cz",
        kategorie: "Finance",
        nabidka: "AirBank",
        typ: "Click",
        id: "213",
        odmena: "170",
        castka: "7,123.45",
    },
    {
        key: "5",
        datum: "25.12.2021 16:00",
        uzivatel: "Matej Horvat",
        zeme: "Slovensko",
        flagCode: "sk",
        kategorie: "Finance",
        nabidka: "Tatra Banka",
        typ: "iFrame",
        id: "214",
        odmena: "190",
        castka: "4,567.89",
    },
];
